import clsx from 'clsx';
import React from 'react';

import useExpander from '@/_hooks/useExpander';
import { fireGAEvent } from '@/analytics';
import { ArrowOrange } from 'nike-ui/src/components/Arrows/Arrows';

function Accordion({ title, expanded, children, className, count, trackingData, ...rest }) {
    const [stateExpanded, onToggle] = useExpander(expanded);
    const clickHandler = e => {
        if (trackingData) {
            const { category, action, label } = trackingData;
            fireGAEvent(category, action.replace('$STATE', stateExpanded ? 'Close' : 'Open'), label);
        }
        onToggle(e);
    };

    return (
        <div className={clsx('accordion', className, { active: stateExpanded })} {...rest}>
            <h1 className="accordion-head" onClick={clickHandler}>
                {!title || typeof title === 'string' ? <span>{title}</span> : title}
                {/* Uncomment once https://jira.nike.sk/browse/VVP-19240 backend is ready. */}
                {/*{count ? <label>{count}</label> : null}*/}
                <AccordionArrow expanded={stateExpanded} />
            </h1>
            {stateExpanded ? <div className="accordion-content">{children}</div> : null}
        </div>
    );
}

export const AccordionArrow = ({ expanded }) => (
    <ArrowOrange sizeX="16" sizeY="16" otherClassName={clsx({ 'arrow-up': expanded })} />
);

export default Accordion;
